import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faRocket,
	faXmark,
	faCircleCheck,
	faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';

import './styles.scss';

const STORAGE_KEY_PREFIX = 'dysmate2_launch_announcement_seen_v2';
const USER_SUPPORT_URL = 'https://literate.no/brukerstotte/';

const getStorageKey = (userId) =>
	userId ? `${STORAGE_KEY_PREFIX}_${userId}` : STORAGE_KEY_PREFIX;

class Dysmate2AnnouncementModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: false,
		};
	}

	componentDidMount() {
		const {currentUser} = this.props;
		const storageKey = getStorageKey(currentUser && currentUser.id);

		let hasSeenAnnouncement = false;
		try {
			hasSeenAnnouncement = localStorage.getItem(storageKey) === 'true';
		} catch (error) {
			hasSeenAnnouncement = false;
		}

		if (!hasSeenAnnouncement) {
			this.setState({isVisible: true});
		}
	}

	dismiss = () => {
		const {currentUser} = this.props;
		const storageKey = getStorageKey(currentUser && currentUser.id);

		try {
			localStorage.setItem(storageKey, 'true');
		} catch (error) {
			// localStorage full or unavailable — the popup may reappear next visit
		}

		this.setState({isVisible: false});
	};

	render() {
		if (!this.state.isVisible) {
			return null;
		}

		return (
			<div
				className="lit-modal lit-announcement-modal"
				onClick={this.dismiss}
			>
				<div
					className="lit-announcement-modal__island"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<button
						type="button"
						className="lit-announcement-modal__close"
						aria-label="Lukk"
						onClick={this.dismiss}
					>
						<FontAwesomeIcon icon={faXmark} />
					</button>

					<div className="lit-announcement-modal__header">
						<span className="lit-announcement-modal__badge">
							<FontAwesomeIcon icon={faRocket} />
							Lansert
						</span>
						<h2 className="lit-announcement-modal__title">
							Dysmate-2 er nå lansert for alle våre brukere
						</h2>
					</div>

					<div className="lit-announcement-modal__body">
						<p>
							<strong>
								VIKTIG: For å være sikker på at dere får tilgang
								på den nyeste versjonen anbefaler vi på det
								sterkeste at dere frisker opp («refresher»)
								testleder-siden ett par ganger. Dette gjelder
								også for elever som skal logge inn på testsiden.
							</strong>
						</p>

						<div className="lit-announcement-modal__divider" />

						<h3 className="lit-announcement-modal__subtitle">
							Gjør deg kjent med Dysmate-2
						</h3>
						<p>
							For å gjøre overgangen så enkel som mulig har vi
							opprettet en egen del i{' '}
							<strong>Brukerstøtte</strong> som kun omhandler
							Dysmate-2, og som vi anbefaler på det sterkeste at
							du tar en titt på. Her finner du nyttige spørsmål og
							svar, i tillegg til korte fagvideoer som senere vil
							inngå i det reviderte nettkurset. Innholdet er laget
							for å gjøre deg trygg på den nye versjonen og gi deg
							den informasjonen du trenger før du tar testene i
							bruk.
						</p>

						<p className="lit-announcement-modal__list-label">
							Videoene tar blant annet for seg:
						</p>
						<ul className="lit-announcement-modal__list">
							<li>
								<FontAwesomeIcon icon={faCircleCheck} />
								Innholdet i de ulike kapitlene i den nye
								Håndboka
							</li>
							<li>
								<FontAwesomeIcon icon={faCircleCheck} />
								En gjennomgang av de tre nye deltestene
							</li>
						</ul>

						<p>
							Det aller meste i Dysmate-2 vil være kjent for deg
							som allerede bruker Dysmate i dag. De største
							endringene er{' '}
							<strong>beskrevet i Brukerstøtte.</strong> Utover
							dette består Dysmate-2 i stor grad av forbedringer
							og videreutvikling av det du allerede kjenner.{' '}
							<strong>
								Den nye Håndboka blir tilgjengelig mot slutten
								av uken
							</strong>
							, og vi anbefaler alle testledere å gjøre seg kjent
							med den så snart den publiseres.
						</p>

						<p>
							<strong>
								Tidligere gjennomførte tester og testresultater
								påvirkes ikke av oppdateringen og vil være
								tilgjengelige akkurat som før. Ny sertifisering
								kreves ikke.
							</strong>
						</p>
					</div>

					<div className="lit-announcement-modal__actions">
						<a
							className="lit-announcement-modal__cta"
							href={USER_SUPPORT_URL}
							target="_blank"
							rel="noopener noreferrer"
							onClick={this.dismiss}
						>
							Gå til Brukerstøtte
							<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
						</a>
						<button
							type="button"
							className="lit-announcement-modal__dismiss"
							onClick={this.dismiss}
						>
							Lukk
						</button>
					</div>
				</div>
			</div>
		);
	}
}

Dysmate2AnnouncementModal.propTypes = {
	currentUser: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}),
};

Dysmate2AnnouncementModal.defaultProps = {
	currentUser: null,
};

export default Dysmate2AnnouncementModal;
